export const environment = {
  production: false,
  // WIP backend running locally over HTTPS
  apiBaseUrl: 'https://quotebotwip.we-sure.co.il/quotebot'
  //apiBaseUrl: 'https://10.140.84.2:20103/api'
  //apiBaseUrl: 'https://wip-int-lb.wesure.co.il:20103/api'
  //apiBaseUrl: 'https://10.150.91.11:20103/api'
  //apiBaseUrl: 'https://10.70.2.33:8104/api'
};
